import {
  type AlarmConditionResultRow,
  type AlarmConditionV2,
  type CompositeAlarmConditionResultRow,
  type CompositeAlarmConditionV2,
  isSimpleAlarmCondition,
  type SimpleAlarmConditionResultRow,
  type SimpleAlarmConditionV2,
} from "../protocols/alerts";

import { notEmpty } from "./core";
import { isLeafNode, treeFlatMap } from "./tree";

export function flattenAlarmCondition(
  ac: AlarmConditionV2,
): SimpleAlarmConditionV2[] {
  return treeFlatMap<
    SimpleAlarmConditionV2,
    CompositeAlarmConditionV2,
    SimpleAlarmConditionV2 | null
  >(ac, (v) => (isSimpleAlarmCondition(v) ? v : null)).filter(notEmpty);
}

export function flattenResultRow(
  rr: AlarmConditionResultRow,
): SimpleAlarmConditionResultRow[] {
  return treeFlatMap<
    SimpleAlarmConditionResultRow,
    CompositeAlarmConditionResultRow,
    SimpleAlarmConditionResultRow | null
  >(rr, (v) => (isLeafNode(v) ? v : null)).filter(notEmpty);
}
